import Chaplin from 'chaplin';

const Answer = Chaplin.Model.extend({});

export default Answer;
